var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHorizontalSingleStackedBarChart({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "F568DAFC-5946-4978-8D11-F99D3841F008") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    fill: "#666666",
    transform: "translate(0.000000, 5.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9,5 L19,5 L19,1 L9,1 L9,5 Z M1,5 L8,5 L8,1 L1,1 L1,5 Z M19,0 L1,0 C0.448,0 0,0.448 0,1 L0,5 C0,5.552 0.448,6 1,6 L19,6 C19.552,6 20,5.552 20,5 L20,1 C20,0.448 19.552,0 19,0 L19,0 Z",
    id: "Fill-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.5,8 L5.5,8 C5.225,8 5,8.225 5,8.5 L5,9.5 C5,9.775 5.225,10 5.5,10 L6.5,10 C6.775,10 7,9.775 7,9.5 L7,8.5 C7,8.225 6.775,8 6.5,8",
    id: "Fill-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5,8 L13.5,8 C13.225,8 13,8.225 13,8.5 L13,9.5 C13,9.775 13.225,10 13.5,10 L14.5,10 C14.775,10 15,9.775 15,9.5 L15,8.5 C15,8.225 14.775,8 14.5,8",
    id: "Fill-4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHorizontalSingleStackedBarChart);
export default __webpack_public_path__ + "static/media/HorizontalSingleStackedBarChart.63ecd177525444923413d5367a1ef79c.svg";
export { ForwardRef as ReactComponent };